import { render, staticRenderFns } from "./Freight.vue?vue&type=template&id=0d9877d4&scoped=true&"
import script from "./Freight.vue?vue&type=script&lang=js&"
export * from "./Freight.vue?vue&type=script&lang=js&"
import style0 from "./Freight.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Freight.vue?vue&type=style&index=1&id=0d9877d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9877d4",
  null
  
)

export default component.exports